<template>
    <layout-gestao v-cloak>
        <div class="row">
            <div class="col-sm-12">
                <form autocomplete="off" method="post" data-vv-scope="form" @keyup.enter="() => {}">
                    <div class="row mb-3">
                        <div class="col-sm-auto">
                                <h1 class="content-title">{{ titleItem }}</h1>
                        </div>
                    </div>

                    <!-- HOME PAGE -->
                    <div class="row">
                        <div class="col-12">
                            <h6 class="font-weight-normal w-100 cursor-pointer" href="#home-page" data-toggle="collapse" aria-expanded="false" aria-controls="#home-page">
                                {{ $t(`${translateID}.home.divider`) }}
                            </h6>
                            <hr class="mt-2" />
                        </div>
                    </div>
                    <div class="row collapse" id="home-page">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label>{{ $t(`${translateID}.home.title`) }}</label>
                                <div class="city-form-group" :class="{'is-invalid': fnHasError('home_title') }">
                                    <ckeditor
                                        name="home_title"
                                        v-model="form.home.title"
                                        :disabled="readonlyFormItem"
                                        :editor="cKEditor.editor"
                                        :config="cKEditor.editorConfig"
                                        v-validate="'min:3'">
                                    </ckeditor>
                                    <small v-if="fnFirstError('home_title')" class="d-block invalid-feedback">{{ fnFirstError('home_title') }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-home_title_news"
                                name="home_title_news"
                                v-model.trim="form.home.news.title"
                                v-validate="{required: false, 'min':3}"
                                :inputClasses="[{'is-invalid':
                                fnHasError('home_title_news') }]"
                                :error="fnFirstError('home_title_news')" >
                                {{ $t(`${translateID}.home.news_title`) }}
                            </MaterialInput>
                        </div>
                        <div class="col-sm-6">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                type="number"
                                class="city-form-group city-bg"
                                id="input-home_news_slider"
                                name="home_news_slider"
                                v-model.trim="form.home.news.slider"
                                v-validate="'required|integer|min_value:2'"
                                :inputClasses="[{'is-invalid':
                                fnHasError('home_news_slider') }]"
                                :error="fnFirstError('home_news_slider')" >
                                {{ $t(`${translateID}.home.news_slider`) }}
                            </MaterialInput>
                        </div>
                        <div class="col-sm-6">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                type="number"
                                class="city-form-group city-bg"
                                id="input-home_news_order"
                                name="home_news_order"
                                v-model.trim="form.home.news.order"
                                v-validate="'required|integer|min_value:1'"
                                :inputClasses="[{'is-invalid':
                                fnHasError('home_news_order') }]"
                                :error="fnFirstError('home_news_order')" >
                                {{ $t(`${translateID}.home.news_order`) }}
                            </MaterialInput>
                        </div>
                        <div class="col-sm-12">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-home_modules_title"
                                name="home_modules_title"
                                v-model.trim="form.home.modules.title"
                                v-validate="{required: false, 'min':3}"
                                :inputClasses="[{'is-invalid':
                                fnHasError('home_modules_title') }]"
                                :error="fnFirstError('home_modules_title')" >
                                {{ $t(`${translateID}.home.modules_title`) }}
                            </MaterialInput>
                        </div>
                        <div class="col-sm-6">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                type="number"
                                class="city-form-group city-bg"
                                id="input-home_modules_limit"
                                name="home_modules_limit"
                                v-model.trim="form.home.modules.limit"
                                v-validate="'integer|min_value:1'"
                                :inputClasses="[{'is-invalid':
                                fnHasError('home_modules_limit') }]"
                                :error="fnFirstError('home_modules_limit')" >
                                {{ $t(`${translateID}.home.modules_limit`) }}
                            </MaterialInput>
                        </div>
                        <div class="col-sm-6">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                type="number"
                                class="city-form-group city-bg"
                                id="input-home_modules_order"
                                name="home_modules_order"
                                v-model.trim="form.home.modules.order"
                                v-validate="'required|integer|min_value:1'"
                                :inputClasses="[{'is-invalid':
                                fnHasError('home_modules_order') }]"
                                :error="fnFirstError('home_modules_order')" >
                                {{ $t(`${translateID}.home.modules_order`) }}
                            </MaterialInput>
                        </div>
                    </div>

                    <!-- NEWS -->
                    <div class="row">
                        <div class="col-12">
                            <h6 class="pt-3 font-weight-normal w-100 cursor-pointer" href="#news" data-toggle="collapse" aria-expanded="false" aria-controls="#news">
                                {{ $t(`${translateID}.news.divider`) }}
                            </h6>
                            <hr class="mt-2" />
                        </div>
                    </div>
                    <div class="row collapse" id="news">
                        <div class="col-sm-8">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-news_title"
                                name="news_title"
                                v-model.trim="form.news.title"
                                v-validate="{required: true, 'min':3}"
                                :inputClasses="[{'is-invalid':
                                fnHasError('news_title') }]"
                                :error="fnFirstError('news_title')" >
                                {{ $t(`${translateID}.news.title`) }}
                            </MaterialInput>
                        </div>
                        <div class="col-sm-4">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                :disabled="readonlyFormItem"
                                type="number"
                                class="city-form-group city-bg"
                                id="input-news_per_page"
                                name="news_per_page"
                                v-model.trim="form.news.per_page"
                                v-validate="'required|integer|min_value:4'"
                                :inputClasses="[{'is-invalid':
                                fnHasError('news_per_page') }]"
                                :error="fnFirstError('news_per_page')" >
                                {{ $t(`${translateID}.news.per_page`) }}
                            </MaterialInput>
                        </div>
                    </div>

                    <buttons-footer
                        :enableButtons="!readonlyFormItem"
                        :cancelTitle="cancelTitle"
                        :submitTitle="submitTitle"
                        :isDisabled="isDisabled"
                        @save="beforeSaveItem"
                        @cancel="handleBack(`${moduleCode}.${pageID}`)"
                    >
                    </buttons-footer>
                </form>
            </div>
        </div>
    </layout-gestao>
</template>

<script>
import GeneralMixin from '../../mixin'
import CkEditorConfigMixin from '@/app/shared/mixins/ckeditor/BaseCkEditorConfigMixin';

export default {
    mixins: [
        GeneralMixin,
        CkEditorConfigMixin
    ],
    data() {
        return {
            pageID: 'settings',
            translateID: 'global_settings',
            toolbarType: 'basic',
            form: {
                home: {
                    title: '',
                    news: {
                        title: null,
                        slider: null,
                        order: null,
                    },
                    modules: {
                        title: null,
                        limit: null,
                        order: null,
                    },
                },
                news: {
                    title: null,
                    per_page: null,
                }
            },
        }
    },
    mounted() {
        this.loadConfig()
        .then( res => {
        });
    },
    computed: {
        titleItem() {
            return this.configTitle + ' - ' + this.pageTitle;
        },
        readonlyFormItem() {
            return !this.canConfigEdit;
        },
    },
    methods: {
        beforeSaveItem: function() {
            if(!this.readonlyFormItem) {
                this.saveItem(null, [], {}, true);
            }
        },
    },
}
</script>

<style>
.ck-editor .ck-content.ck-editor__editable {
    min-height: 150px;
    max-height: 150px;
}
</style>